const getters = {
  navbarStatus: state => state.app.navbarStatus,
}
export default getters
